
/**
 * BADGE DE STATUT DE PAIEMENT
 */
export const PaymentStatusBadge = ({ facturation }) => {
  if (facturation.hasPaid) {
    return (
      <span className="badge rounded-pill fw-medium px-3 py-2 bg-success bg-opacity-10 text-success border border-success border-opacity-25">
        <i className="fas fa-check-double me-1"></i>
        Payée
      </span>
    );
  }else {
    return (
      <span className="badge rounded-pill fw-medium px-3 py-2 bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25">
        <i className="fas fa-clock me-1"></i>
        En attente
      </span>
    );
  }
};

/**
 * BADGE DE STATUT DE PAIEMENT DE COMMISSION
 */
export const PaymentCommissionStatusBadge = ({ facturation }) => {
  if (facturation.commissionPaid) {
    return (
      <span className="badge rounded-pill fw-medium px-3 py-2 bg-success bg-opacity-10 text-success border border-success border-opacity-25">
        <i className="fas fa-check-double me-1"></i>
        Commission Payée
      </span>
    );
  } else {
    return (
      <span className="badge rounded-pill fw-medium px-3 py-2 bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25">
        <i className="fas fa-clock me-1"></i>
        En attente
      </span>
    );
  }
};

/**
 * BADGE DE STATUT DE FACTURATION
 */
export const FacturationStatusBadge = ({ facturation }) => {
  const isValidated = facturation.facturationStatut === 1;

  if (isValidated) {
    return (
      <span className="badge rounded-pill fw-medium px-3 py-2 bg-success bg-opacity-10 text-success border border-success border-opacity-25">
        <i className="fas fa-check-circle me-1"></i>
        Validée
      </span>
    );
  } else {
    return (
      <span className="badge rounded-pill fw-medium px-3 py-2 bg-secondary bg-opacity-10 text-secondary-emphasis border border-secondary border-opacity-25">
        <i className="fas fa-edit me-1"></i>
        Brouillon
      </span>
    );
  }
};